import { BazaarVoiceApi } from '../types/api/bazaar-voice-api';
import { BAZAAR_VOICE_URL } from '../constants';
import { Method, callAxios } from '../axios';

export const bazaarVoiceApiFetchers = {
  getBazaarVoiceFetcher: async (params: string) => {
    const GET_BAZAARVOICE_URL = process.env.REACT_APP_DEV === 'mock'
      ? 'http://localhost:3100/get-bazaar-voice'
      : `${BAZAAR_VOICE_URL}?${params}`;
    const response = await callAxios<{
      response: BazaarVoiceApi.BazaarVoiceResponse;
    }>({
      method: Method.GET,
      url: GET_BAZAARVOICE_URL,
    });

    return response.data;
  },
};
